import { useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { ChatContext } from './ChatContext';
import { UserContext } from '../user/UserContext';
import { SocketContext } from '../socket/SocketContext';
import { fetchUnreadCountApi } from '../../features/messages/api/messages.api';

export default function ChatProvider({ children }) {
  const [unreadMsgCount, setUnreadMsgCount] = useState(0);
  const { loggedIn } = useContext(UserContext);
  const { socket } = useContext(SocketContext);

  const fetchUnreadCount = useCallback(async () => {
    if (!loggedIn) return;
    try {
      const data = await fetchUnreadCountApi();
      setUnreadMsgCount(data.unreadCount || 0);
    } catch (err) {
      console.error('Error fetching unread count:', err);
    }
  }, [loggedIn]);

  useEffect(() => {
    if (loggedIn && socket) {
      fetchUnreadCount();

      const handleNewMessageNotification = (data) => {
        setUnreadMsgCount((prev) => prev + 1);
      };

      socket.on('new-message-notification', handleNewMessageNotification);

      return () => {
        socket.off('new-message-notification', handleNewMessageNotification);
      };
    } else {
      setUnreadMsgCount(0);
    }
  }, [loggedIn, socket, fetchUnreadCount]);

  const value = useMemo(
    () => ({
      unreadMsgCount,
      setUnreadMsgCount,
      fetchUnreadCount,
    }),
    [unreadMsgCount, fetchUnreadCount]
  );

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
}
